export default {
    noOptions: "List is empty.",
    noResult: "No elements found. Consider changing the search query.",
    placeholder: "Choose option",
    tagPlaceholder: "Press enter for a new entry",
    selectLabel: "Press enter to select",
    selectGroupLabel: "Press enter to select group",
    selectedLabel: "Selected",
    deselectLabel: "Press enter to remove",
    deselectGroupLabel: "Press enter to remove group",
}
